module.exports = "/images/logo-pajakku-38b478018ddb91e0bd2e9f52fb267a06.png";